<template>
    <div class="catOperWrap">
        <!-- <img src="//assets.lepucdn.cn/vuetest/images/zhuanti/catOper.jpeg" alt=""> -->
        <div class="topBanner">
            <img src="//assets.lepucdn.cn/vue/images/zhuanti/yunying/bigBanner.jpg" alt="">
        </div>
        <div class="center">
            <div class="center_aboutme">
                <img src="//assets.lepucdn.cn/vue/images/zhuanti/yunying/aboutme.jpg" alt="">
            </div>
            <div class="center_text">
                猫哥运营是隶属于猫哥科技旗下的专业外卖运营品牌，是一家集营销策划、运营托管、品牌打造，供给整合等一站式服务型企业；自创立以来，秉承着“专业至上”的服务理念，结合专业的运营水平，丰富的实战经验，先进的技术手段来帮助外卖商家成功解决线上运营的各种难题；现已拥有自己独立的运营团队、设计团队、创意团队以及数据分析团队，可为线上餐饮企业量身定制从商户端到平台端的运营方案，提供7*24小时全天候管家式全托管运营服务，如店铺装修、外卖运营、店铺评价维护、logo(VI)设计、菜品图片拍摄、外卖海报制作、外卖经营咨询、餐饮品牌体系打造、品牌招商、餐饮培训等服务；迄今为止，我们已在重庆、上海等地开设了分支企业，服务合作商家遍布全国300多个城市，累计服务商家已超过10000+，我们将为打造中国外卖运营第一品牌励志前行！
            </div>
            <div class="center_aboutImg">
                <img src="//assets.lepucdn.cn/vue/images/zhuanti/yunying/aboutimg.jpg" alt="">
            </div>
        </div>
        <div class="bottom">
            <img src="//assets.lepucdn.cn/vue/images/zhuanti/yunying/botImg.jpg" alt="">
        </div>
        <div class="bookingBtn">
            <button @click="zixunClick">
                <i class="iconfont icon-dibudianhua"></i>
                免费咨询
            </button>
        </div>
    </div>
</template>
<script>
export default {
    name: "catOper",
    data(){
        return{

        }
    },
    methods:{
        zixunClick(){
            this.ajax.get('//api.lepu.cn/app/activity/ad').then(res=>{
                var res = res.data
                if(res.status == 1 && res.data.code == 1){
                    window.location.href = 'tel:' + res.data.data.tel
                }else{
                    this.$toast({
                        message: res.note,
                        position: 'middle',
                        duration: 2000
                    })
                }
            })
        },
        getData(){
            this.ajax.get('//api.lepu.cn/app/activity/ad-view').then(res=>{
                var res = res.data
                if(res.status == 1 && res.data.code == 1){
                    // window.location.href = 'tel:' + res.data.data.tel
                }else{
                    this.$toast({
                        message: res.note,
                        position: 'middle',
                        duration: 2000
                    })
                }
            })
        }
    },
    created(){
        this.getData()
    }
}
</script>
<style lang="scss" scoped>
.catOperWrap{
    width: 100%;
    padding-bottom: 1.08rem;
    box-sizing: border-box;
}

.topBanner,.bottom{
    width: 100%;
    height: auto;

    img{
        width: 100%;
    }
}

.center{
    width: 100%;
    background: #000;
    padding-top: .6rem;
    padding-bottom: .3rem;
    box-sizing: border-box;

    .center_aboutme{
        width: 100%;
        text-align: center;
        margin-bottom: .2rem;
        
        &>img{
            width: 50%;
        }
    }

    .center_aboutImg{
        width: 100%;
        text-align: center;

        &>img{
            width: 90%;
        }
    }
}

.center_text{
    color: #fff;
    font-size: .22rem;
    line-height: .36rem;
    padding: 0 .2rem;
    box-sizing: border-box;
    text-indent: .3rem;
    margin-bottom: .3rem;
}

.bookingBtn{
    width: 100%;
    height: 1.2rem;
    line-height: 1.2rem;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: .24rem .2rem;
    box-sizing: border-box;

    button{
        width: 100%;
        height: 100%;
        text-align: center;
        color: #fff;
        background: #d90020;
        border: none;
        border-radius: .1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .3rem;

        i{
            margin-right: .1rem;
            font-size: .38rem;
        }
    }
}

.zuxunBt>div{
    background: #86aaff;
    color: #fff;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: .04rem;
    font-size: .3rem;
}
</style>
